import type { MarketplaceCurrency } from '@/types';
import { Star } from 'lucide-react';

const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 });

/** Format a price in USD or tokens. `0` USD is treated as "Contact for pricing". */
export function formatPrice(amount: number, currency: MarketplaceCurrency = 'usd'): string {
  if (currency === 'tokens') return `${amount.toLocaleString()} tokens`;
  if (!amount) return 'Contact for pricing';
  return usd.format(amount);
}

/** Read-only 5-star rating display. */
export function Stars({ value, size = 14 }: { value: number; size?: number }) {
  return (
    <span className="inline-flex items-center" aria-label={`${value.toFixed(1)} out of 5`}>
      {[0, 1, 2, 3, 4].map((i) => (
        <Star
          key={i}
          width={size}
          height={size}
          className={i < Math.round(value) ? 'fill-amber-400 text-amber-400' : 'text-gray-300'}
        />
      ))}
    </span>
  );
}
